import { useMemo } from "react";
import { useContextSystemView } from "@/app/module/index";

export function useSystemView() {
  const {
    systemViewState,
    delegateUserData,
    fetchSaveSystemView,
    fetchResetSystemView,
  } = useContextSystemView();

  return useMemo(
    () => ({
      status: systemViewState,
      userData: delegateUserData,
      save: fetchSaveSystemView,
      reset: fetchResetSystemView,
    }),
    [
      systemViewState,
      delegateUserData,
      fetchSaveSystemView,
      fetchResetSystemView,
    ],
  );
}
